<template>
  <span v-if="styleConfig" class="sample-type-tag" :style="styleConfig">
    {{ label }}
  </span>
</template>

<script>
const SAMPLE_TYPE_TAG_MAP = {
  Saliva: {
    label: "Saliva",
    backgroundColor: "#E6F3FF",
    textColor: "#246A99",
  },
  Urine: {
    label: "Urine",
    backgroundColor: "#FFF8D9",
    textColor: "#ADA81F",
  },
  Stool: {
    label: "Stool",
    backgroundColor: "#F7EFE6",
    textColor: "#8A6329",
  },
  DBS: {
    label: "DBS",
    backgroundColor: "#FFF1E6",
    textColor: "#885627",
  },
  Microtube: {
    label: "Microtube",
    backgroundColor: "#F3E9FF",
    textColor: "#6E45A1",
  },
  "Urine (4 Tubes)": {
    label: "Urine (4 Tubes)",
    backgroundColor: "#F5F2E0",
    textColor: "#776A2A",
  },
  "Saliva (6 Tubes)": {
    label: "Saliva (6 Tubes)",
    backgroundColor: "#C6E0FF",
    textColor: "#153E66",
  },
  Blood: {
    label: "Blood",
    backgroundColor: "#FDEAEA",
    textColor: "#B93A3A",
  },
  UR: {
    label: "UR",
    backgroundColor: "#FFF8D9",
    textColor: "#ADA81F",
  },
  UR4: {
    label: "UR4",
    backgroundColor: "#F5F2E0",
    textColor: "#776A2A",
  },
  SA: {
    label: "SA",
    backgroundColor: "#E6F3FF",
    textColor: "#246A99",
  },
  SA6: {
    label: "SA6",
    backgroundColor: "#C6E0FF",
    textColor: "#153E66",
  },
  SL: {
    label: "SL",
    backgroundColor: "#F7EFE6",
    textColor: "#8A6329",
  },
  MT: {
    label: "MT",
    backgroundColor: "#F3E9FF",
    textColor: "#6E45A1",
  },
  BD: {
    label: "BD",
    backgroundColor: "#FDEAEA",
    textColor: "#B93A3A",
  },
};

export default {
  name: "TestSampleTypeTagNew",
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    config() {
      return SAMPLE_TYPE_TAG_MAP[this.type] || null;
    },
    label() {
      return this.config ? this.config.label : this.type;
    },
    styleConfig() {
      if (!this.config) return null;
      return {
        backgroundColor: this.config.backgroundColor,
        color: this.config.textColor,
      };
    },
  },
};
</script>

<style scoped>
.sample-type-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  height: 20px;
  border-radius: 12px;
  font-size: 12px;
  line-height: 18px;
  font-weight: 500;
  font-family: "IBM Plex Sans Hebrew";
  letter-spacing: 0.5px;
  white-space: nowrap;  
}
</style>